import { Skeleton } from "@mui/material";
import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./style.module.scss";

interface MetricTileSkeletonProps {
  /** Must mirror what the loaded tile will render, or the layout jumps. */
  withIcon?: boolean;
  withDelta?: boolean;
  withDefinition?: boolean;
  emphasis?: boolean;
  /** Extra placeholder content, e.g. a donut, between value and delta. */
  children?: ReactNode;
  className?: string;
}

function MetricTileSkeleton({
  withIcon = true,
  withDelta = true,
  withDefinition,
  emphasis,
  children,
  className,
}: MetricTileSkeletonProps) {
  return (
    <div className={classNames(styles.tile, emphasis && styles.emphasis, className)}>
      <div className={styles.head}>
        <Skeleton variant="text" width="60%" height={emphasis ? 18 : 16} />
        {withIcon && (
          <Skeleton
            variant="rounded"
            width={emphasis ? 32 : 26}
            height={emphasis ? 32 : 26}
            sx={{ borderRadius: "8px", flexShrink: 0 }}
          />
        )}
      </div>

      <div className={styles.figure}>
        <Skeleton variant="text" width={86} height={emphasis ? 40 : 36} />
        <Skeleton variant="text" width={54} height={16} />
      </div>

      {children}

      {withDelta && (
        <div className={styles.delta}>
          <Skeleton
            variant="rounded"
            width={130}
            height={20}
            sx={{ borderRadius: "12px" }}
          />
        </div>
      )}

      {withDefinition && (
        <div className={styles.definition}>
          <Skeleton variant="text" width="100%" height={14} />
          <Skeleton variant="text" width="72%" height={14} />
        </div>
      )}
    </div>
  );
}

export default MetricTileSkeleton;
